import {PageTab, WidgetCard} from 'components';
import {UserContext} from 'context';
import {useContext} from 'react';
import {ViewMMCCore} from 'components/mmld';
import InlineAddMMC from 'components/mmld/InlineAddMMC';

const EndorsementsTab = () => {
    const {hasMmlds} = useContext(UserContext);

    return (
        <PageTab>
            <WidgetCard title={hasMmlds ? null : 'Enter Your MMC'}>
                {!hasMmlds && <InlineAddMMC />}
                {hasMmlds && <ViewMMCCore />}
            </WidgetCard>
        </PageTab>
    );
};

export default EndorsementsTab;
